import { ApiCallStatus } from '../../../services/api-call-status';
import { RootState } from '../../../store';

export const selectEventCreationStatus = (state: RootState): ApiCallStatus => state.calendarEvent.status;
export const selectEventCreationStatusErrorMessage = (state: RootState): string => state.calendarEvent.error;
